import "prismjs/themes/prism.css"
require("./src/scss/init.scss")
